@if (!userHasImage) {
  <div class="user-image" [ngClass]="{'no-initials': userWithoutInitials}">
    <span class="user-initials">{{userInitials}}</span>
  </div>
}
@if (userHasImage) {
  <img class="user-image" alt="user" src="/api/User/Image/{{user.GlobalPersonUid}}" />
}
